import React, { useState, useCallback, useEffect } from 'react';
import DashboardLayout from 'layout/dashboardLayout';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import Status from 'components/common/status';
import SuccessModal from 'components/SuccessModal';
import CautionGif from 'assets/animations/gifs/caution.gif';
import classname from 'classname';
import { CloseModal, SearchTableIcon } from 'components/icons';
import { fetchTransactionFromSource } from 'store/actions/dashboard';
import moment from 'moment';
import styles from './terminal.module.scss';
import { BackArrow, ChevronRight } from '../../assets/svgs';
import { globalStyles } from '../../styles';
import DateFilter from '../../components/DateFilter';
import TerminalDetailsTable from './components/TerminalDetailsTable';
import { formatDateForApi } from '../../libs';

const TerminalDetails = () => {
  const history = useHistory();
  const location = useLocation();

  const [page, setPage] = useState(0);
  const [date, setDate] = useState({ from: '', to: '' });
  const [modal, showModal] = useState(false);
  const [status, setStatus] = React.useState('ALL');

  let details = {};

  if (location?.state) {
    details = location.state;
  }

  const onCloseModal = () => {
    showModal(false);
  };

  const openModal = () => {
    showModal(true);
  };

  const dispatch = useDispatch();
  const limit = 20;

  const getTransactions = useCallback(
    (params) => {
      dispatch(fetchTransactionFromSource(params));
    },
    [dispatch],
  );

  const handlePageClick = (data) => {
    setPage(data.selected + 1);
    getTransactions({ ...pagination, page: data.selected });
  };

  useEffect(() => {
    const formattedStartDate = formatDateForApi(date.from);
    const formattedEndDate = formatDateForApi(date.to);
    const source = 'TERMINAL';

    const params = {
      ...(formattedStartDate && { startDate: formattedStartDate }),
      ...(formattedEndDate && { endDate: formattedEndDate }),
      ...(status !== 'ALL' && { status }),
      source,
    };

    if (date.from && date.to) {
      getTransactions(params);
    }
  }, [getTransactions, date, status]);

  const { transactionsFromSource } = useSelector((state) => state.dashboard);

  const { data: txt, pagination, inProgress } = transactionsFromSource;

  const handleStatusChange = (sts) => {
    setStatus(sts?.toUpperCase());
  };

  return (
    <DashboardLayout>
      <div
        className={styles.terminalListContent}
        data-testid="terminal-details"
      >
        <div className={styles.contentHeader}>
          <div className={styles.contentHeaderLeft}>
            <div
              className={styles.contentHeaderLeftNavButton}
              onClick={() => history.push('/terminal')}
            >
              <BackArrow />
            </div>
            <div className={styles.contentHeaderLeftNavWrapper}>
              <p className={styles.contentHeaderLeftNavWrapperTitle}>
                {details?.merchantId?.businessName || '-'}
              </p>
              <p className={styles.contentHeaderLeftNavWrapperText}>
                {details.serialNumber || '-'}
              </p>
            </div>
          </div>
          <div className={styles.contentHeaderRight}>
            {/* <button onClick={() => openModal()}> */}
            {/*  <p>Unassign Terminal</p> */}
            {/* </button> */}
          </div>
        </div>
        <span className={styles.contentHeaderStroke} />
        <div className={styles.contentInformation}>
          <p className={styles.contentInformationLabel}>Basic Information</p>
          <div className={styles.contentInformationDetails}>
            <div className={styles.contentInformationDetailsWrapper}>
              <p className={styles.contentInformationDetailsWrapperLabel}>
                Terminal ID
              </p>
              <p className={styles.contentInformationDetailsWrapperValue}>
                {details.terminalId || '-'}
              </p>
            </div>
            <div className={styles.contentInformationDetailsWrapper}>
              <p className={styles.contentInformationDetailsWrapperLabel}>
                Serial Number
              </p>
              <p className={styles.contentInformationDetailsWrapperValue}>
                {details.serialNumber || '-'}
              </p>
            </div>
            <div className={styles.contentInformationDetailsWrapper}>
              <p className={styles.contentInformationDetailsWrapperLabel}>
                Date issued
              </p>
              <p className={styles.contentInformationDetailsWrapperValue}>
                {details.createdAt &&
                  moment(details.createdAt).format('DD MMMM YYYY hh:mm A')}
              </p>
            </div>
            {/* <div className={styles.contentInformationDetailsWrapper}> */}
            {/*  <p className={styles.contentInformationDetailsWrapperLabel}> */}
            {/*    Label */}
            {/*  </p> */}
            {/*  <p className={styles.contentInformationDetailsWrapperValue}> */}
            {/*    {details.label || '-'} */}
            {/*    <span */}
            {/*      className={ */}
            {/*        styles.contentInformationDetailsWrapperValueEditButton */}
            {/*      } */}
            {/*    > */}
            {/*      edit */}
            {/*    </span> */}
            {/*  </p> */}
            {/* </div> */}
          </div>
          <span className={styles.contentInformationStroke} />
        </div>
        <div className={styles.contentInformation}>
          <div
            className={classname(styles.transactionHeader, globalStyles.flex)}
          >
            <div className={styles.contentInformationLabel}>
              Terminal Transactions
            </div>
            <button
              type="button"
              className={styles.contentInformationViewAllBtn}
              onClick={() =>
                history.push({
                  pathname: '/transactions',
                  state: { source: 'TERMINAL' },
                })
              }
            >
              <p>View all</p>
              <ChevronRight />
            </button>
          </div>
          <div className={styles.contentInformationHeader}>
            <div className={classname(globalStyles.tablesearchcontainer)}>
              <SearchTableIcon
                className={classname(
                  globalStyles.tablesearchicon,
                  styles.searchBar,
                )}
              />
              <input
                type="text"
                placeholder="Search by any field"
                className={classname(
                  globalStyles.tablesearch,
                  styles.searchBar,
                )}
              />
            </div>
            <div>
              <DateFilter date={date} setDate={setDate} showBorder />
            </div>
            <Status
              altStatuses={['Successful', 'Failed']}
              active="Assigned"
              firstItem="ALL"
              variant="blue"
              handleClick={handleStatusChange}
            />
          </div>
          <TerminalDetailsTable
            inProgress={inProgress}
            page={page}
            meta={pagination}
            txt={txt}
            handlePageClick={handlePageClick}
            setPage={setPage}
          />
        </div>
      </div>
      {modal && (
        <SuccessModal
          positiveBtn={onCloseModal}
          negativeBtn={onCloseModal}
          decorationIcon={
            <img src={CautionGif} width="150" height="150" alt="" />
          }
          title="Are you sure you want to unassign “terminal name”?"
          subtitle="This action is irrevesible"
          buttonText="Yes, Unassign"
          secondButtonText="No, Cancel"
          buttonStyle={styles.firstModalButton}
          showNegativeButton
          closeIcon={<CloseModal />}
          titleStyle={styles.modalTitle}
        />
      )}
    </DashboardLayout>
  );
};

export default TerminalDetails;
